module.exports = __webpack_public_path__ + "media/images/japan/tips_3-3719283c48682cf1b9a60021464e9182.jpg";